import React, { Component } from 'react'

import Nav from './Nav'
// import Version from './Version'

class Layout extends Component {
  render() {
    return (
      <div className='layout'>
        <Nav location={this.props.location} />
        <div className='bone'>{this.props.children}</div>
        {/* <Version /> */}
      </div>
    )
  }
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/Bone/Layout.js